// extracted by mini-css-extract-plugin
export var widthFix = "bigBlockCard-module--widthFix--CpT+X";